export default __webpack_public_path__ + "static/media/hightower-logo.5f891f6a.png";